import axiosInstance from "../../axios/instance";
import { normalizeToUTC } from "@revbox/helpers-fe";
import { getToken } from "../../helpers/get-token";
async function getPeriodCampaignInventoryStats(currentPeriod, previousPeriod, campaignId, current_token, view, page, search, sortingParams) {    
    try {
        if (!currentPeriod[0] || !previousPeriod[0] || !campaignId || !view) {
            return {
                success: false,
                message: "Invalid parameters"
            }
        }
        const token = current_token || getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;
        
        const requestBody = {
            current_period: [normalizeToUTC(currentPeriod[0]).getTime(), normalizeToUTC(currentPeriod[1]).getTime()],
            previous_period: [normalizeToUTC(previousPeriod[0]).getTime(), normalizeToUTC(previousPeriod[1]).getTime()],
            campaign_id: campaignId,
            view: view,
            table_filters: {
                search: search || '',
                page: page || 1,
                limit: 10
            }
        };

        // Add sorting params if provided
        if (sortingParams?.columnName && sortingParams?.sortOrder) {
            requestBody.table_filters.sort_column = sortingParams.columnName;
            requestBody.table_filters.sort_direction = sortingParams.sortOrder;
        }

        console.log('📡 API sending sortingParams:', sortingParams);
        console.log('📡 API sending table_filters:', requestBody.table_filters);

        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/analytics/campaign/period/inventory-stats', requestBody)

        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodCampaignInventoryStats;
